'use strict';

angular.module('cvsApp')
  .controller('AccountBalanceCtrl', ["$scope", "$state", "userSession", 'webAnalytics', '$rootScope', 'doPaymentService', 'commonFunctionality','cvsAppData','$cookies','loggerService', 'loggerServiceHelper',
    function ($scope, $state, UserSession, webAnalytics, $rootScope, doPaymentService, commonFunctionality, CAD, $cookies, loggerService, loggerServiceHelper) {
      var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.BALANCE));
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));

      $scope.content = wcmContent;

      var eppflow = $cookies.get('epp', { path: '/'});
      if (eppflow === 'Y') {
        window.location.href = window.location.origin + '/FASTPROXY/ngx-payments/#/payments/account-balance';
      }

      $scope.returnToRegistration=function(refill){
        if(!refill){
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestPaymentSubmittedRegisterAndRefill");
        }
        /*$scope.switchTab("QR");*/
        CAD.setOPTabData({isSelected: false});
        CAD.setRFRTabData({isSelected: false});
        CAD.setQRTabData({isSelected: true});
        CAD.setTAPTabData({isSelected: false});
        /**/
        $state.go("RR");
      }

      $scope.continue = function () {
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("makeAPaymentBtnClick") + loggerServiceHelper.setDescription("Make a payment button is clicked"));
        localStorage.clear();
        Object.keys(UserSession.persit).forEach(function (key) {
          delete UserSession.persit[key];
        });
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
        $state.go("make-payment");
      };
      //cvsUtility.resetSessoinTimeOut();
      if (cvsUtility.queryMap.accessKey && cvsUtility.queryMap.tokenId) {
        UserSession.postRegistrationFlow = true;
        UserSession.init(true, "registered");
      }

      /*Scroll to top*/
      cvsUtility.genralPostMessage("SCROLL_TO", {
        "scroll": true
      });


      $scope.disableAutopay = function () {
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("DisableAutomaticPayment") + loggerServiceHelper.setDescription("Disable Automatic payment from autopay banner"));
        commonFunctionality.disableAutoPay();
      };
      $scope.getNextPayment = function () {
        return moment().set('date', UserSession.autoPay.schedule).add(1, 'months').format("MM/DD/YYYY");
      };

      $scope.editMopRecurring = function () {
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("EditAutomaticPayment") + loggerServiceHelper.setDescription("Navigating to payment method page"));
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
        $state.go("payment-methods", {
          'paymenttype': 'auto'
        });
      }
      $scope.showAutoPay = function () {
        if (UserSession.accountData.activeMop) {
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep("AutomaticPaymentEnabled"));
          UserSession.autoPay.enabled = true;
          UserSession.paymentMethod = UserSession.accountData.activeMop.paymentMethodId;
          //UserSession.paymentMopType = UserSession.accountData.getMopById(UserSession.paymentMethod).payment.method;
          UserSession.autoPay.schedule = UserSession.accountData.activeMop.payment.frequency && UserSession.accountData.activeMop.payment.frequency == "IMMEDIATE" ? 0 : UserSession.accountData.activeMop.payment.frequency;
          UserSession.reviewPageAutoPay.limit = UserSession.accountData.activeMop.payment.amount;
          //_paymentType="auto";*/
          return true;
        } else if (UserSession.accountData.currentBalance === 0) {
          UserSession.autoPay.enabled = false;
          return true
        }
        return false;
        //return UserSession.accountData.currentBalance === 0 || (UserSession.accountData.currentBalance !== 0 && UserSession.autoPay.enabled === true);
      };
      $scope.showNextPayment = function () {
        if (UserSession && UserSession.autoPay && UserSession.autoPay.enabled !== true) {
          return false;
        }
        if (UserSession && UserSession.accountData && UserSession.accountData.currentBalance == 0 && UserSession.autoPay.schedule != 0) {
          return true;
        }
      };

      $scope.renewAch = function () {
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("renewACHAuthorization") + loggerServiceHelper.setDescription("Renew ACH authorization"));
        commonFunctionality.renewACH();
      };

      if (!$scope.$parent.angularComponentLoaded && cvsUtility.queryMap.open && cvsUtility.queryMap.open == "payment") {
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep("makeAPaymentBtnClick") + loggerServiceHelper.setDescription("Navigating to makeAPayment as open is payment"));
        $state.go("make-payment");
      } else if (!$scope.$parent.angularComponentLoaded && cvsUtility.queryMap.open && cvsUtility.queryMap.open == "recurring") {
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep("setUpRecurringPaymentBtnClick") + loggerServiceHelper.setFlowType("AutomaticPayment") + loggerServiceHelper.setDescription("Navigating to paymentMethod as open is recurring"));
        $state.go("payment-methods", {
          'paymenttype': 'auto'
        });
      } else {

        var utagObj = {
          tsrc: cvsUtility.queryMap.source
        };
        setTimeout(function () {
          if (!UserSession.registered) {

            /**
             * sankar 11/22/2016 - ITPR017031 - guest account balance
             * Added WTS pagename tag
             */
            if (self == top) {
              utagObj.pagename = 'PAYMENT-guestAccountBalance';
            }
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestAccountBalance");
          } else {

            /**
             * sankar 11/22/2016 - ITPR017031 - account balance
             * Added WTS pagename tag
             */
            if (self == top) {
              utagObj.pagename = 'PAYMENT-accountBalance';
            }
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "accountBalance");
          }
        }, 3000);

        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Loading Account Balance and Payments Page completed."));

      }

      var destroyEvent = $rootScope.$on('retreiveFormofPaymentServiceCallDone', function (event, args) {
        if (!$rootScope.paymentConfirmationPageReturn && cvsUtility.queryMap.open && cvsUtility.queryMap.open == "editAutoPayAmountFrequency") {
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep("EditAutomaticPayment") + loggerServiceHelper.setDescription("Navigating to Automatic Payment  page"));
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          $scope.showAutoPay();
          $state.go("automatic-payments");
        } else if (!$rootScope.paymentConfirmationPageReturn && cvsUtility.queryMap.open && cvsUtility.queryMap.open == "editAutoPayAccount") {
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep("EditAutomaticPayment") + loggerServiceHelper.setDescription("Navigating to payment method page"));
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          $scope.editMopRecurring();
        }
      });

      $scope.$on('$destroy', destroyEvent);

      $rootScope.$on('SERVER-ERROR', function (event, args) {
        $scope.SERVER_ERROR = true;
      });
      $scope.$parent.angularComponentLoaded = true;

    }
  ]);